import { module } from 'modujs'
import { CUSTOM_EVENT, ENV, VARS } from '../config'
import { gsap } from '../lib/gsap'
import { clamp } from '../utils/maths'

export default class extends module {
    constructor(m) {
        super(m)

        this.$el = this.el
        this.$inner = this.$('inner')[0]
        this.$items = Array.from(this.$('item'))
        this.$itemsInner = this.$items.map($item => $item.children)
        this.$videos = this.$items.map($item => $item.querySelector('video')).filter(v => v)
        this.$overlay = this.$('overlay')[0]
    }

    init() {

        if(ENV.REDUCED_MOTION) {
            return
        }

        this.setTimeline()

        window.addEventListener(CUSTOM_EVENT.RESIZE_END, this.resizeBind = () => this.setTimeline())
    }

    setTimeline() {

        if(this.tl) {
            gsap.set(this.$inner, { clearProps: 'scale' })
            gsap.set(this.$items, { clearProps: 'borderWidth' })
            gsap.set(this.$itemsInner, { clearProps: 'scale' })
            gsap.set(this.$overlay, { clearProps: 'opacity' })
            this.tl?.kill()
        }

        const gap = Math.round(clamp(12, 32, 0.0175 * VARS.window.width))

        this.tl = gsap.timeline({
            scrollTrigger: {
                trigger: this.$el,
                start: 'top top',
                end: 'bottom top',
                scrub: true,
                onLeave: () => {
                    for(let $video of this.$videos) {
                        $video.pause()
                    }
                },
                onEnterBack: () => {
                    for(let $video of this.$videos) {
                        $video.play()
                    }
                }
            },
            defaults: {
                ease: 'none',
            }
        })

        this.tl
            .fromTo(this.$itemsInner,
                {
                    scale: 2
                },
                {
                    scale: 1,
                },
            0)
            .fromTo(this.$inner,
                {
                    scale: 1
                },
                {
                    scale: 0.5,
                    duration: 0.67,
                },
            0.33)
            .fromTo(this.$items,
                {
                    borderWidth: 0
                },
                {
                    borderWidth: gap,
                    duration: 0.67,
                },
            0.33)
            .fromTo(this.$overlay,
                {
                    opacity: 1,
                },
                {
                    opacity: 0,
                    duration: 0.33,
                },
            0)
    }

    destroy() {

        if(ENV.REDUCED_MOTION) {
            return
        }

        this.tl?.kill()
        window.removeEventListener(CUSTOM_EVENT.RESIZE_END, this.resizeBind)
    }
}
